/**
 * dadosPessoais.js — o que NÃO sai do navegador junto com um log de erro.
 *
 * Todo erro HTTP do Admin vai para o card de erros do Dashboard com o corpo da requisição
 * (`api.js` → errorLogService → /console/errors). Desde 10/10/2026 a compra leva CPF ou CNPJ e
 * razão social no corpo; Configurações também. O VALOR dessas chaves sai; a chave fica, para o
 * diagnóstico saber que o campo veio. Pega também o CPF de cliente final das fichas de pessoa.
 * Espelho de HandledErrorTrackingMiddleware.MascararDadosPessoais (API) — mesmas chaves.
 * Plano: docs/PLANO-DOCUMENTO-CPF-CNPJ-E-COBRANCA.md (revisão).
 */

const CHAVE_PESSOAL = /document|cpf|cnpj|billingname/i;

/**
 * Cópia do objeto com os valores pessoais trocados por '[REDACTED]'. Não altera o original
 * (é o mesmo objeto que o axios ainda pode usar). Primitivo/null passam direto.
 * @param {any} valor
 * @returns {any}
 */
export function ocultarDadosPessoais(valor) {
  if (Array.isArray(valor)) return valor.map(ocultarDadosPessoais);
  if (!valor || typeof valor !== 'object') return valor;
  return Object.fromEntries(Object.entries(valor).map(([chave, v]) => [
    chave,
    CHAVE_PESSOAL.test(chave) && v != null ? '[REDACTED]' : ocultarDadosPessoais(v),
  ]));
}
